{
  "buttons": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "continue": "Continuar",
    "back": "Atrás",
    "submit": "Enviar",
    "delete": "Eliminar",
    "edit": "Editar",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "next": "Siguiente",
    "previous": "Anterior",
    "upload": "Subir",
    "download": "Descargar",
    "refresh": "Actualizar",
    "retry": "Reintentar",
    "learnMore": "Más información",
    "getStarted": "Comenzar",
    "viewDetails": "Ver detalles",
    "saveChanges": "Guardar cambios"
  },
  "labels": {
    "email": "Correo electrónico",
    "name": "Nombre",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "phone": "Teléfono",
    "company": "Empresa",
    "companyName": "Nombre de la empresa",
    "country": "País",
    "address": "Dirección",
    "city": "Ciudad",
    "state": "Provincia",
    "postcode": "Código postal",
    "website": "Sitio web",
    "description": "Descripción",
    "date": "Fecha",
    "status": "Estado",
    "actions": "Acciones",
    "type": "Tipo",
    "category": "Categoría",
    "notes": "Notas"
  },
  "status": {
    "loading": "Cargando...",
    "saving": "Guardando...",
    "success": "¡Éxito!",
    "error": "Se produjo un error",
    "pending": "Pendiente",
    "completed": "Completado",
    "inProgress": "En progreso",
    "draft": "Borrador",
    "active": "Activo",
    "inactive": "Inactivo"
  },
  "validation": {
    "required": "Este campo es obligatorio",
    "invalidEmail": "Por favor ingrese un correo electrónico válido",
    "minLength": "Debe tener al menos {{min}} caracteres",
    "maxLength": "No debe tener más de {{max}} caracteres",
    "invalidPhone": "Por favor ingrese un número de teléfono válido",
    "invalidUrl": "Por favor ingrese una URL válida"
  },
  "errors": {
    "generic": "Algo salió mal. Por favor intente de nuevo.",
    "network": "Error de red. Por favor verifique su conexión.",
    "unauthorized": "No está autorizado para realizar esta acción.",
    "notFound": "El recurso solicitado no fue encontrado.",
    "serverError": "Error del servidor. Por favor intente más tarde."
  },
  "navigation": {
    "home": "Inicio",
    "dashboard": "Panel de control",
    "settings": "Configuración",
    "profile": "Perfil",
    "logout": "Cerrar sesión",
    "login": "Iniciar sesión",
    "signUp": "Registrarse",
    "help": "Ayuda",
    "support": "Soporte"
  },
  "time": {
    "today": "Hoy",
    "yesterday": "Ayer",
    "lastWeek": "La semana pasada",
    "lastMonth": "El mes pasado",
    "ago": "hace",
    "minutes": "minutos",
    "hours": "horas",
    "days": "días"
  },
  "language": {
    "select": "Seleccionar idioma",
    "en": "English",
    "es": "Español",
    "de": "Deutsch",
    "zh": "中文"
  }
}
